module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/479.0413241e.png";